import {
    Activite,
    Fournisseur,
    Contact,
    Client,
    Lieu,
    CentreServiceScolaire,
    Entente,
    Produit,
    ModeleHoraire,
} from '../entities/index';

export const RECHERCHE_API = '/recherche' as const;
export const RECHERCHE_VITRINE_API = '/recherche/vitrine' as const;
export const RECHERCHE_PAGE_URL = '/dashboard/recherche' as const;

export interface ReponseRechercheApi {
    activites: Activite[];
    fournisseurs: Fournisseur[];
    contacts: Contact[];
    clients: Client[];
    lieux: Lieu[];
    centresSS: CentreServiceScolaire[];
    ententes: Entente[];
    produits: Produit[];
    modelesHoraire: ModeleHoraire[];
}

export function estVide(rep: ReponseRechercheApi): boolean {
    let result = true;

    result = result && rep.activites.length === 0;
    result = result && rep.fournisseurs.length === 0;
    result = result && rep.clients.length === 0;
    result = result && rep.contacts.length === 0;
    result = result && rep.lieux.length === 0;
    result = result && rep.centresSS.length === 0;
    result = result && rep.ententes.length === 0;

    return result;
}

export interface RequeteRechercheApi {
    requete: string;
    nombre?: number;
    justePublique?: boolean;
}

export const reponseVide: ReponseRechercheApi = {
    activites: [],
    fournisseurs: [],
    contacts: [],
    clients: [],
    lieux: [],
    centresSS: [],
    ententes: [],
    produits: [],
    modelesHoraire: [],
};
